import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _changeCurrencyRequest = {};
var _changeCurrencyResponse = {};
var _createTicketDefinitionRequest = { definition: '_ticketDefinitionData' };
var _createTicketDefinitionResponse = { definition: '_ticketDefinition' };
var _deleteTicketDefinitionRequest = {};
var _deleteTicketDefinitionResponse = {};
var _getTicketDefinitionRequest = {};
var _getTicketDefinitionResponse = { definition: '_ticketDefinition' };
var _listTicketDefinitionsRequest = {};
var _listTicketDefinitionsResponse = { definitions: '_ticketDefinition' };
var _queryTicketDefinitionsRequest = {};
var _queryTicketDefinitionsResponse = { definitions: '_ticketDefinition' };
var _queryTicketDefinitionsV2Request = {};
var _queryTicketDefinitionsV2Response = { definitions: '_ticketDefinition' };
var _ticketDefinition = { salePeriod: '_ticketSalePeriod' };
var _ticketDefinitionData = { salePeriod: '_ticketSalePeriod' };
var _ticketSalePeriod = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _updateTicketDefinitionRequest = {
    fields: 'google.protobuf.FieldMask',
    definition: '_ticketDefinitionData',
};
var _updateTicketDefinitionResponse = { definition: '_ticketDefinition' };
function resolveWixEventsTicketingTicketDefinitionManagementUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/events-ticketing-v1-proxy',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        _: [
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definition',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/events-ticketing-v1-proxy/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/events-ticketing-v1-proxy/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Ticket Definition V3's [Query Ticket Definitions](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definition-v3/query-ticket-definitions) and will be removed on October 26, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves a list of up to 100 ticket definitions, supporting [structurized queries](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_query-ticket-definitions).
 */
export function queryTicketDefinitions(payload) {
    var _a = serializer(_queryTicketDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryTicketDefinitionsResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __queryTicketDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.TicketDefinitionManagement.QueryTicketDefinitions',
            url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
                protoPath: '/v1/ticket-definitions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryTicketDefinitions.fromReq = fromReq;
    __queryTicketDefinitions.__isAmbassador = true;
    return __queryTicketDefinitions;
}
/** Retrieves a list of up to 100 ticket definitions, supporting [structurized queries](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_query-ticket-definitions). */
export function queryTicketDefinitionsV2(payload) {
    var _a = serializer(_queryTicketDefinitionsV2Request, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryTicketDefinitionsV2Response, {
        _ticketDefinition: _ticketDefinition,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __queryTicketDefinitionsV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.TicketDefinitionManagement.QueryTicketDefinitionsV2',
            url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
                protoPath: '/v2/ticket-definitions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryTicketDefinitionsV2.fromReq = fromReq;
    __queryTicketDefinitionsV2.__isAmbassador = true;
    return __queryTicketDefinitionsV2;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Ticket Definition V3's [Query Ticket Definitions](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definition-v3/query-ticket-definitions) and will be removed on October 26, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves a list of up to 100 ticket definitions, with basic filter support.
 */
export function listTicketDefinitions(payload) {
    var _a = serializer(_listTicketDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTicketDefinitionsResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __listTicketDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_definition',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.TicketDefinitionManagement.ListTicketDefinitions',
            url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
                protoPath: '/v1/ticket-definitions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTicketDefinitions.fromReq = fromReq;
    __listTicketDefinitions.__isAmbassador = true;
    return __listTicketDefinitions;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Ticket Definition V3's [Get Ticket Definition](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definition-v3/get-ticket-definition) and will be removed on October 26, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Retrieves a ticket definition.
 */
export function getTicketDefinition(payload) {
    var _a = serializer(_getTicketDefinitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTicketDefinitionResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __getTicketDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_definition',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.TicketDefinitionManagement.GetTicketDefinition',
            url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
                protoPath: '/v1/ticket-definitions/{definitionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTicketDefinition.fromReq = fromReq;
    __getTicketDefinition.__isAmbassador = true;
    return __getTicketDefinition;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Ticket Definition V3's [Create Ticket Definition](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definition-v3/create-ticket-definition) and will be removed on October 26, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Creates a ticket definition (and enables ticket sales).
 */
export function createTicketDefinition(payload) {
    var _a = serializer(_createTicketDefinitionRequest, { _ticketDefinitionData: _ticketDefinitionData, _ticketSalePeriod: _ticketSalePeriod }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTicketDefinitionResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __createTicketDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.TicketDefinitionManagement.CreateTicketDefinition',
            url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
                protoPath: '/v1/ticket-definitions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTicketDefinition.fromReq = fromReq;
    __createTicketDefinition.__isAmbassador = true;
    return __createTicketDefinition;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Ticket Definition V3's [Update Ticket Definition](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definition-v3/update-ticket-definition) and will be removed on October 26, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Updates a ticket definition. See [partial updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information.
 */
export function updateTicketDefinition(payload) {
    var _a = serializer(_updateTicketDefinitionRequest, { _ticketDefinitionData: _ticketDefinitionData, _ticketSalePeriod: _ticketSalePeriod }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTicketDefinitionResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __updateTicketDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_definition',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketing.TicketDefinitionManagement.UpdateTicketDefinition',
            url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
                protoPath: '/v1/ticket-definitions/{definitionId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTicketDefinition.fromReq = fromReq;
    __updateTicketDefinition.__isAmbassador = true;
    return __updateTicketDefinition;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Ticket Definition V3's [Delete Ticket Definition](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definition-v3/delete-ticket-definition) and will be removed on October 26, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Deletes a ticket definition. (Does not affect tickets that were already ordered).
 */
export function deleteTicketDefinition(payload) {
    var _a = serializer(_deleteTicketDefinitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTicketDefinitionResponse, {}).fromJSON;
    function __deleteTicketDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_definition',
            method: 'DELETE',
            methodFqn: 'wix.events.ticketing.TicketDefinitionManagement.DeleteTicketDefinition',
            url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
                protoPath: '/v1/ticket-definitions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTicketDefinition.fromReq = fromReq;
    __deleteTicketDefinition.__isAmbassador = true;
    return __deleteTicketDefinition;
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with Ticket Definition V3's [Change Currency](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definitions-v3/change-currency) and will be removed on October 26, 2024.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 * Changes the currency for all tickets (per event).
 */
export function changeCurrency(payload) {
    var _a = serializer(_changeCurrencyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changeCurrencyResponse, {}).fromJSON;
    function __changeCurrency(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_definition',
            method: 'PUT',
            methodFqn: 'wix.events.ticketing.TicketDefinitionManagement.ChangeCurrency',
            url: resolveWixEventsTicketingTicketDefinitionManagementUrl({
                protoPath: '/v1/ticket-definitions/currency',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changeCurrency.fromReq = fromReq;
    __changeCurrency.__isAmbassador = true;
    return __changeCurrency;
}
//# sourceMappingURL=http.impl.js.map